import React from 'react';
import './GetInvolved.css';

const GetInvolved = () => {
  return (
    <div className="get-involved-container">
      <h1>Get Involved</h1>
      <p className="intro-text">
        Join us in our mission to strengthen the child-welfare ecosystem. There are multiple ways to contribute and make a difference.
      </p>

      <div className="options-grid">
        <div className="option-card">
          <h2>Volunteer With Us</h2>
          <p>
            Work directly with our team to support our mission. Help us develop and implement 
            marketing and sales tools that empower non-profits in the child-welfare sector.
          </p>
          <ul className="opportunities-list">
            <li>Content Creation & Marketing</li>
            <li>Tool Development & Testing</li>
            <li>Community Outreach</li>
            <li>Event Planning & Support</li>
          </ul>
          <button className="action-button">Apply to Volunteer</button>
        </div>

        <div className="option-card">
          <h2>Volunteer With Partners</h2>
          <p>
            Connect with our partner organizations working directly in child welfare. 
            Make an immediate impact in your community through our network of trusted non-profits.
          </p>
          <ul className="opportunities-list">
            <li>Direct Service Opportunities</li>
            <li>Mentoring Programs</li>
            <li>Educational Support</li>
            <li>Community Events</li>
          </ul>
          <button className="action-button">View Partner Opportunities</button>
        </div>

        <div className="option-card">
          <h2>Join Our Team</h2>
          <p>
            Become part of our growing team dedicated to transforming the non-profit sector. 
            We're always looking for passionate individuals who share our vision.
          </p>
          <ul className="opportunities-list">
            <li>Full-time Positions</li>
            <li>Part-time Roles</li>
            <li>Internship Programs</li>
            <li>Advisory Positions</li>
          </ul>
          <button className="action-button">View Open Positions</button>
        </div>
      </div>
    </div>
  );
};

export default GetInvolved; 